<template>
    <div class="h-1 w-full bg-base-content/10 rounded-full">
      <div :style="fillerStyles" class="flex justify-end  items-center leading-1 text-xs bg-accent h-full rounded-inherit text-right transition-all duration-1000 ease-in-out">
        <span 
            class="px-1 text-black/90 font-bold flex justify-end"
            v-if="showText"
        >{{ `${completed}%` }}</span>
      </div>
    </div>
  </template>
  
  <script setup>
  import { computed, toRefs } from "vue";
  
  const props = defineProps({
    bgcolor: String,
    completed: Number,
    showText: {
      type: Boolean,
      default: true,
    },
  });
  
  const { bgcolor, completed } = toRefs(props);
  
  const fillerStyles = computed(() => ({
    width: `${completed.value}%`,
    backgroundColor: bgcolor.value,
  }));
  </script>
  
  <style scoped>
  .rounded-inherit {
    border-radius: inherit;
  }
  </style>